export default __webpack_public_path__ + "static/media/preloader.7dbb5c66.svg";